export const locDivCdData = [
    {value : "CAB00" , label : "전CM"} ,
    {value : "CBA00" , label : "후CM"}
];

export const yoilData = [
    {value : 1 , label : '일' , commCd : "SAG07" , wkFlag : "Y"} ,
    {value : 2 , label : '월' , commCd : "SAG01" , wkFlag : "N"} ,
    {value : 3 , label : '화' , commCd : "SAG02" , wkFlag : "N"} ,
    {value : 4 , label : '수' , commCd : "SAG03" , wkFlag : "N"} ,
    {value : 5 , label : '목' , commCd : "SAG04" , wkFlag : "N"} ,
    {value : 6 , label : '금' , commCd : "SAG05" , wkFlag : "N"} ,
    {value : 7 , label : '토' , commCd : "SAG06" , wkFlag : "Y"} ,
]

export const areaData = [
    {label : "전국" , value : "00"} ,
    {label : "수도권" , value : "50"} ,
]

export const brdData = [
    {value : "030" , label : "SBS"} ,
    {value : "999" , label : "민영"} ,
    {value : "031" , label : "민영"} ,
];

//캠페인 계약구분
export const perfReqTypeData = [
    /*cpm*/
    {value : "SNP03" , label : "CPM" , etc1 : "SRB01"} ,
    {value : "SNP04" , label : "CPRP" , etc1 : "SRB01"} ,
    /*cprp*/
    {value : "SNP05" , label: "시청률" , etc1 : "SRB02"} ,
    {value : "SNP06" , label: "보너스" , etc1 : "SRB02"} ,
];


export const tgIdcCdData = [
    {value : "SNO01" , label : "CPRP(시청률)", perfReqType : "SNP05"} ,
    {value : "SNO02" , label : "CPM(시청자수)", perfReqType : "SNP05"} ,
    {value : "SNP06" , label : "보너스율", perfReqType : "SNP06"} ,
];

//신청가능 초수
export const mtrlData = [
    {label : "15초" , value : "15"} ,
    {label : "20초" , value : "20"} ,
    {label : "30초" , value : "30"} ,
    {label : "45초" , value : "45"} ,
    {label : "60초" , value : "60"} ,
];

export const tgGenderData = [
    {label : "개인" , value : "put"} ,
    {label : "남자" , value : "m"} ,
    {label : "여자" , value : "f"}
]

//5세단위 타켓선택 시작 나이
export const tgAgeStData = [
    {label : "전체" , value : "0"} ,
    {label : "4세" , value : "4"} ,
    {label : "10세" , value : "10"} ,
    {label : "15세" , value : "15"} ,
    {label : "20세" , value : "20"} ,
    {label : "25세" , value : "25"} ,
    {label : "30세" , value : "30"} ,
    {label : "35세" , value : "35"} ,
    {label : "40세" , value : "40"} ,
    {label : "45세" , value : "45"} ,
    {label : "50세" , value : "50"} ,
    {label : "55세" , value : "55"} ,
    {label : "60세" , value : "60"} ,
]
///5세단위 타켓선택 끝 나이
export const tgAgeEdData = [
    {label : "9세" , value : "9"} ,
    {label : "14세" , value : "14"} ,
    {label : "19세" , value : "19"} ,
    {label : "24세" , value : "24"} ,
    {label : "29세" , value : "29"} ,
    {label : "34세" , value : "34"} ,
    {label : "39세" , value : "39"} ,
    {label : "44세" , value : "44"} ,
    {label : "49세" , value : "49"} ,
    {label : "54세" , value : "54"} ,
    {label : "59세" , value : "59"} ,
    {label : "64세" , value : "64"} ,
    {label : "65+" , value : "65"} ,
]

export const adKndCdData = [
    {label : "중간광고" , value : "SPB11" , ord : 1} ,
    {label : "프로그램" , value : "SPB01" , ord : 2} ,
    {label : "토막광고" , value : "SPB02" , ord : 3} ,
]

export const staticsOptData = [
    {label : "금액(천원)" , value : "sbscrPrc" , ord : 1, } ,
    {label : "횟수(회)" , value : "sbscrCnt" , ord : 2} ,
    {label : "초수(초)" , value : "sec" , ord : 3} ,
    {label : "GRP" , value : "grps" , ord : 4} ,
    {label : "시청자수(천명)" , value : "predViwrIdc" , ord : 5} ,
]

export const lmtTimeCdData = [
    {label : "주류" , value : "SRA01" , ord : 2} ,
    {label : "청소년유해매체물" , value : "SRA02" , ord : 3} ,
    {label : "고열량저열량고카페인" , value : "SRA05" , ord : 4} ,
]

export const compTypeCdData = [
    {label : "MC" , value : "SAA01" , ord : 1, } ,
    {label : "광고회사" , value : "SAA03" , ord : 2} ,
    {label : "광고주" , value : "SAA04" , ord : 3} ,
    {label : "방송사" , value : "SAA06" , ord : 4} ,
    {label : "기타" , value : "SAA99" , ord : 5} ,
] ;

export const tgAllListData  = [
     { tgGender : "put"  , tgNm :"개인_전체", minAge :"0", maxAge :"99", tgColNm :"put", repColNm:"PUT" }
   , { tgGender : "totm"  , tgNm :"남자전체", minAge :"0", maxAge :"99", tgColNm :"tot_m", repColNm:"M_TOT" }
   , { tgGender : "totf"  , tgNm :"여자전체", minAge :"0", maxAge :"99", tgColNm :"tot_f", repColNm:"F_TOT" }
   , { tgGender : "f"  , tgNm :"여 4-9", minAge :"4", maxAge :"9", tgColNm :"f_04,f_05,f_06,f_07,f_08,f_09", repColNm:"F0409" }
   , { tgGender : "f"  , tgNm :"여 10-14", minAge :"10", maxAge :"14", tgColNm :"f_10,f_11,f_12,f_13,f_14", repColNm:"F1014" }
   , { tgGender : "f"  , tgNm :"여 15-19", minAge :"15", maxAge :"19", tgColNm :"f_15,f_16,f_17,f_18,f_19", repColNm:"F1519" }
   , { tgGender : "f"  , tgNm :"여 20-24", minAge :"20", maxAge :"24", tgColNm :"f_20,f_21,f_22,f_23,f_24", repColNm:"F2024" }
   , { tgGender : "f"  , tgNm :"여 25-29", minAge :"25", maxAge :"29", tgColNm :"f_25,f_26,f_27,f_28,f_29", repColNm:"F2529" }
   , { tgGender : "f"  , tgNm :"여 30-34", minAge :"30", maxAge :"34", tgColNm :"f_30,f_31,f_32,f_33,f_34", repColNm:"F3034" }
   , { tgGender : "f"  , tgNm :"여 35-39", minAge :"35", maxAge :"39", tgColNm :"f_35,f_36,f_37,f_38,f_39", repColNm:"F3539" }
   , { tgGender : "f"  , tgNm :"여 40-44", minAge :"40", maxAge :"44", tgColNm :"f_40,f_41,f_42,f_43,f_44", repColNm:"F4044" }
   , { tgGender : "f"  , tgNm :"여 45-49", minAge :"45", maxAge :"49", tgColNm :"f_45,f_46,f_47,f_48,f_49", repColNm:"F4549" }
   , { tgGender : "f"  , tgNm :"여 50-54", minAge :"50", maxAge :"54", tgColNm :"f_50,f_51,f_52,f_53,f_54", repColNm:"F5054" }
   , { tgGender : "f"  , tgNm :"여 55-59", minAge :"55", maxAge :"59", tgColNm :"f_55,f_56,f_57,f_58,f_59", repColNm:"F5559" }
   , { tgGender : "f"  , tgNm :"여 60-64", minAge :"60", maxAge :"64", tgColNm :"f_60,f_61,f_62,f_63,f_64", repColNm:"F6064" }
   , { tgGender : "f"  , tgNm :"여 65+", minAge :"65", maxAge :"65", tgColNm :"ov65_f", repColNm:"F65OV" }
   , { tgGender : "m"  , tgNm :"남 4-9", minAge :"4", maxAge :"9", tgColNm :"m_04,m_05,m_06,m_07,m_08,m_09", repColNm:"M0409" }
   , { tgGender : "m"  , tgNm :"남 10-14", minAge :"10", maxAge :"14", tgColNm :"m_10,m_11,m_12,m_13,m_14", repColNm:"M1014" }
   , { tgGender : "m"  , tgNm :"남 15-19", minAge :"15", maxAge :"19", tgColNm :"m_15,m_16,m_17,m_18,m_19", repColNm:"M1519" }
   , { tgGender : "m"  , tgNm :"남 20-24", minAge :"20", maxAge :"24", tgColNm :"m_20,m_21,m_22,m_23,m_24", repColNm:"M2024" }
   , { tgGender : "m"  , tgNm :"남 25-29", minAge :"25", maxAge :"29", tgColNm :"m_25,m_26,m_27,m_28,m_29", repColNm:"M2529" }
   , { tgGender : "m"  , tgNm :"남 30-34", minAge :"30", maxAge :"34", tgColNm :"m_30,m_31,m_32,m_33,m_34", repColNm:"M3034" }
   , { tgGender : "m"  , tgNm :"남 35-39", minAge :"35", maxAge :"39", tgColNm :"m_35,m_36,m_37,m_38,m_39", repColNm:"M3539" }
   , { tgGender : "m"  , tgNm :"남 40-44", minAge :"40", maxAge :"44", tgColNm :"m_40,m_41,m_42,m_43,m_44", repColNm:"M4044" }
   , { tgGender : "m"  , tgNm :"남 45-49", minAge :"45", maxAge :"49", tgColNm :"m_45,m_46,m_47,m_48,m_49", repColNm:"M4549" }
   , { tgGender : "m"  , tgNm :"남 50-54", minAge :"50", maxAge :"54", tgColNm :"m_50,m_51,m_52,m_53,m_54", repColNm:"M5054" }
   , { tgGender : "m"  , tgNm :"남 55-59", minAge :"55", maxAge :"59", tgColNm :"m_55,m_56,m_57,m_58,m_59", repColNm:"M5559" }
   , { tgGender : "m"  , tgNm :"남 60-64", minAge :"60", maxAge :"64", tgColNm :"m_60,m_61,m_62,m_63,m_64", repColNm:"M6064" }
   , { tgGender : "m"  , tgNm :"남 65+", minAge :"65", maxAge :"65", tgColNm :"ov65_m", repColNm:"M65OV" }
   
   
] ;
